import axios from "axios";

const api = axios.create({
  baseURL: "https://api.nationalfinanceolympiad.com/nfo", // Replace with your API base URL
});

export default api;
